import React, { useEffect, useState } from 'react'
import { Grid, Card, CardContent, Typography } from "@deere/fuel-react";
import { getDateFromTimeStamp } from '../../utils/utils';

export default function SurveyInfoCard({ campaign, campaignRes }) {
    const [admin, setAdmin] = useState(undefined)


    useEffect(() => {
        if (campaignRes && campaignRes.length > 0) {
            const found = campaignRes.find(cr => cr.createdby?.trim().toLowerCase() === campaign.createdBy?.trim().toLowerCase())
            found !== undefined ? setAdmin(found) : setAdmin({sentToName: campaign.createdBy})
        } else {
          setAdmin({sentToName: campaign.createdBy});
        }
    }, [campaignRes, campaign])


    return (
        <>
          <Card>
            <CardContent>
              <Grid container spacing={2} p={2}>
                <Grid item xs={6}>
                    <Typography variant="span" style={{ fontWeight: "bold", display: "block" }}>Start Date</Typography>
                    <Typography variant="span" >{getDateFromTimeStamp(campaign.startDate)}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="span" style={{ fontWeight: "bold", display: "block" }}>End Date</Typography>
                    <Typography variant="span" >{getDateFromTimeStamp(campaign.endDate)}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="span" style={{ fontWeight: "bold", display: "block" }}>Created By</Typography>
                    <Typography variant="span" >{`${admin === undefined ? "" : admin.sentToName} on ${getDateFromTimeStamp(campaign.createdTs)}`}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="span" style={{ fontWeight: "bold", display: "block" }}>Campaign Status</Typography>
                    <Typography variant="span" >{campaign.status}</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>
    );
}